import { useEffect } from "react";

/** F5 would drop typed note text. The browser shows its own leave prompt. */
export function useNoteUnloadWarning(text: string, dirty: boolean) {
  useEffect(() => {
    if (!dirty || text.trim() === "") return;
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [dirty, text]);
}
